(function(){
window.__chLoadedAssets=window.__chLoadedAssets||{};
if(window.__chLoadedAssets["ch-animations.js"])return;
window.__chLoadedAssets["ch-animations.js"]=true;
const CH_SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'ch-scroll-trigger';
const CH_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'ch-scroll-trigger--offscreen';
const CH_SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'ch-animate--zoom-in';
const CH_SCROLL_ANIMATION_CANCEL_CLASSNAME = 'ch-scroll-trigger--cancel';

// Scroll in animation logic
function ChOnIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(CH_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(CH_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(CH_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(CH_SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function ChInitializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(CH_SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('ch-scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(ChOnIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function ChInitializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(CH_SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * ChPercentageSeen(element));

    window.addEventListener(
      'scroll',
      ChThrottle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * ChPercentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function ChPercentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  ChInitializeScrollAnimationTrigger();
  ChInitializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => ChInitializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => ChInitializeScrollAnimationTrigger(document, true));
}

window.CH_SCROLL_ANIMATION_TRIGGER_CLASSNAME = CH_SCROLL_ANIMATION_TRIGGER_CLASSNAME;
window.CH_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = CH_SCROLL_ANIMATION_OFFSCREEN_CLASSNAME;
window.CH_SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = CH_SCROLL_ZOOM_IN_TRIGGER_CLASSNAME;
window.CH_SCROLL_ANIMATION_CANCEL_CLASSNAME = CH_SCROLL_ANIMATION_CANCEL_CLASSNAME;
window.ChOnIntersection = ChOnIntersection;
window.ChInitializeScrollAnimationTrigger = ChInitializeScrollAnimationTrigger;
window.ChInitializeScrollZoomAnimationTrigger = ChInitializeScrollZoomAnimationTrigger;
window.ChPercentageSeen = ChPercentageSeen;
})();
